import { AppTask } from "aurelia";
import { IStore } from "@aurelia/state";

import { initialState, IState } from "./state";

function removeNestedKeys(obj: Record<string, any>, keyPaths: string[]) {
  if (keyPaths.length === 0) return obj;
  keyPaths.forEach((keyPath) => {
    const keys = keyPath.split(".");
    let current = obj;
    let defaultValue: Record<string, any> = { ...initialState };
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]];
      defaultValue = defaultValue[keys[i]];
      if (!current) return; // Key path doesn't exist
    }
    current[keys[keys.length - 1]] = defaultValue[keys[keys.length - 1]];
  });
}

export function persistentStatePlugin(stateKey: string, exclusions: string[]) {
  return AppTask.creating(IStore, (store) => {
    // Create a subscriber which listens to all state changes and persists them to localStorage
    store.subscribe({
      handleStateChange: (newState: IState) => {
        // We don't want to modify the actual state in memory, just the copy that
        // will persist
        const finalState = { ...newState };
        removeNestedKeys(finalState, exclusions);
        localStorage.setItem(stateKey, JSON.stringify(finalState));
      },
    });
  });
}
